@use "~theme/typography";
@use "~theme/breakpoints";

.divider {
    display: none;
  
    @include breakpoints.desktop {
      @include typography.heading3;
      display: block;
      padding-bottom: 2px;
      margin: 0 0 50px;
      border: none;
      border-bottom: 4px solid var(--blue-01);
      max-width: 18em;
    }
  }

.headline {
@include typography.heading3;
margin: 0;
}

.container {
    width: 67%; 
    padding-left: 20px;
    display: block;
    overflow: auto;
    float:left;
}

.weekContainer{
    width: 100%;
    height: 80px;
}

.dayContainer {
    width: 12.2%;
    height: 70px;
    /* White */
    background: #FFFFFF;
    /* 03 Grey */
    border: 1px solid #EAEAEA;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    float: left;
    padding: 10px 0px;
    margin: 0px 5px;
    text-align: center;
    cursor:pointer;
    @include breakpoints.tablet {
        width: 11%;  
    }
    @include breakpoints.desktop {
        width: 11%;  
    }
    @include breakpoints.desktop-large {
        width: 12%;  
    }
}

.daySelected {
    border: 1px solid #40668C;
    /* 03 Shadow */
   // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}
.dayWords {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    text-transform: uppercase;
    color: #003366;
}

.monthYear {
    font-weight: 400;
    font-size: 16px;
    color: #231F20;
}

.arrow {    
    float:left;
    margin: 20px 0px;
    a {
        outline: none;
    }
    a:hover {
        border: none;
    }
    a:active {
        outline: none;
    }
    a:focus {
    outline: none;
    }
}

.arrowLeft {
    margin-right: 8px;
}

.arrowRight {
    margin-left: 8px;
}

.seeMoreWaitlist {
    float:left;
    width: 100%;
    margin-top: 10px;
}
.seeMore {
    background: #EEF5FC;
    border-radius: 4px;
    margin: 5px 0px;
    height: 43px;
    text-align: center;
    padding: 10px;
    font-weight: 600;
    font-size: 18px;
    line-height: 140%;
    align-items: center;
    letter-spacing: 0.02em;
    text-decoration: none;
    float:left;
    width: 100%;
    cursor: pointer;
    a {
        text-decoration: none;
    }
}

.emptyHeight{
    height:200px
}

.underLine{
    border: 0.5px solid #CAC6C6;
    position: relative;
    margin-top: 10px;
}

.datePickerBand {
    display: contents;
}

.mobileDateScroller {
    box-sizing: border-box;
    float: none;
    margin: 0;
    padding: 0 20px;
    width: 100%;

    .datePickerBand {
        background: var(--white);
        box-sizing: border-box;
        display: block;
        margin-bottom: 20px;
        margin-left: -20px;
        margin-right: -20px;
        margin-top: 16px;
        padding: 10px 12px 12px;
        width: calc(100% + 40px);
    }

    .headline {
        color: var(--brand-indigo);
        font-family: "Instrument Serif", serif;
        font-size: 24px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: 31px;
        margin: 0;
        width: auto;
    }

    .weekContainer {
        align-items: center;
        display: flex;
        gap: 6px;
        height: 64px;
        margin: 8px 0 10px;
        width: 100%;
    }

    .daysRow {
        display: flex;
        flex: 1 1 auto;
        gap: 6px;
        overflow-x: auto;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .dayContainer {
        border-radius: 10px;
        flex: 0 0 calc((100% - 24px) / 5);
        height: 56px;
        margin: 0;
        padding: 6px 4px;
    }

    .dayWords {
        font-size: 12px;
        letter-spacing: 0;
        line-height: 16px;
    }

    .monthYear {
        font-size: 11px;
        letter-spacing: 0;
        line-height: 14px;
    }

    .arrow {
        display: flex;
        float: none;
        margin: 0;
    }

    @include breakpoints.desktop {
        float: left;
        padding: 0 0 0 20px;
        width: 67%;

        .datePickerBand {
            background: transparent;
            display: contents;
            margin: 0;
            padding: 0;
            width: auto;
        }

        .headline {
            @include typography.heading3;
            margin: 0;
        }

        .weekContainer {
            display: block;
            height: 80px;
            margin: 0;
        }

        .daysRow {
            display: block;
            overflow: visible;
        }

        .dayContainer {
            border-radius: 8px;
            float: left;
            height: 70px;
            margin: 0 5px;
            padding: 10px 0;
            width: 11%;
        }

        .dayWords,
        .monthYear {
            font-size: 16px;
        }

        .arrow {
            float: left;
            margin: 20px 0;
        }
    }
}
